/* eslint-disable react/display-name */
import React from 'react';
import { Switch } from 'react-router-dom';
import CommonDocument from '../container/Document/CommonDocument';
import PrivateDocument from '../container/Document/PrivateDocument';
import SharedDocument from '../container/Document/SharedDocument';

import AuthRoute from './AuthRoute';

const routes = [
  {
    path: '/document/common',
    component: () => <CommonDocument />,
    exact: true,
    meta: {
      action: 'information_public_view',
      subject: 'information'
    }
  },
  {
    path: '/document/private',
    component: () => <PrivateDocument />,
    exact: true,
    meta: {
      action: 'information_private_view',
      subject: 'information'
    }
  },
  {
    path: '/document/share',
    component: () => <SharedDocument />,
    exact: true,
    meta: {
      action: 'information_teachershare_view',
      subject: 'information'
    }
  }
];

const DocumentInfoRoutes = () => {
  if (typeof window !== 'undefined') {
    return (
      <>
        <Switch>
          {routes.map((route) => (
            <AuthRoute key={route.path} {...route} />
          ))}
        </Switch>
      </>
    );
  }
  return '';
};

export default DocumentInfoRoutes;
